/**
 * A screen that could not load, and the way back.
 *
 * Every list and summary in the product needs this, and each one having its own
 * copy is how they drift into saying different things about the same failure —
 * one offering a retry, the next leaving someone on a dead page.
 *
 * It always offers the retry. A failure with no way to try again forces a
 * reload of the whole application to recover from what is usually a single
 * request that timed out.
 */
export function LoadFailed({
  detail,
  onRetry,
}: {
  readonly detail: string
  readonly onRetry: () => void
}) {
  return (
    <div className="rounded-card border border-danger bg-danger-soft p-6 text-center">
      <p className="text-[14px] text-danger">{detail}</p>
      <button
        type="button"
        onClick={onRetry}
        className="mt-3 font-semibold text-[13px] text-danger underline"
      >
        Try again
      </button>
    </div>
  )
}
